let info = {
    email: 'contact.arthur.miranda.dev@gmail.com',
}

export default info;